// Create or edit a route's name + date.
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from '../../../components/shared/Modal';

const Field = styled.div`
  margin-bottom: 14px;
  label { display: block; font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; color: ${p => p.theme.colors.textSecondary}; margin-bottom: 6px; }
  input {
    width: 100%; padding: 11px 12px; font-size: 0.95rem; box-sizing: border-box;
    background: ${p => p.theme.colors.background}; color: ${p => p.theme.colors.textPrimary};
    border: 1.5px solid ${p => p.theme.colors.inputGray}44; border-radius: ${p => p.theme.borderRadius};
  }
`;
const ErrorText = styled.div`color: ${p => p.theme.colors.error}; font-size: 0.82rem; margin-bottom: 10px;`;

const RouteFormModal = ({ isOpen, route = null, onClose, onSave }) => {
  const [name, setName] = useState('');
  const [date, setDate] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    setError('');
    setName(route?.name || '');
    setDate(route?.date || '');
  }, [isOpen, route]);

  const save = async () => {
    if (!name.trim()) { setError('Give the route a name.'); return; }
    try {
      await onSave({ name: name.trim(), date: date || null });
    } catch (err) {
      setError(err.response?.data?.message || 'Could not save the route.');
    }
  };

  if (!isOpen) return null;

  return (
    <Modal title={route ? 'Edit Route' : 'New Route'} isOpen={isOpen} onCancel={onClose} onConfirm={save}>
      {error && <ErrorText>{error}</ErrorText>}
      <Field>
        <label>Route name</label>
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. North Lowell — Monday" />
      </Field>
      <Field>
        <label>Visit date</label>
        <input type="date" value={date || ''} onChange={(e) => setDate(e.target.value)} />
      </Field>
    </Modal>
  );
};

export default RouteFormModal;
